import React, { Component, Fragment } from 'react';

export default Page =>
  class extends Component {
    render() {
      return (
        <Fragment>
          <Page {...this.props} />
        </Fragment>
      );
    }
  };
